/*!jslint this */
jQuery(function ($) {
  "use strict";

  if ('scrollRestoration' in history) {
    // Prevent automatic scroll restoration
    history.scrollRestoration = 'manual';
  }

  function setAppHeight() {
    document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`);
  }

  function handleScrollEffects() {
    const scrollTop = $(window).scrollTop();
    const windowHeight = $(window).height();
    const docHeight = $(document).height();

    if ($('body').hasClass('home')) {
      $('.home-banner').toggleClass('faded-out', scrollTop > windowHeight);
      $('.site-header').toggleClass('fixed', scrollTop > windowHeight / 2);

    }
    if (windowHeight >= docHeight || scrollTop > 300) {
      $('.site-footer').css('opacity', '1');
    } else {
      $('.site-footer').css('opacity', '0');
    }
  }
  const POPUP_KEY = 'subscribePopupClosedAt';
  const POPUP_DELAY_MINUTES = 2;

  function openSubscribeForm() {
    const $popup = $('.subscribe-popup');
    if (!$popup.length || $popup.hasClass('open')) return;

    const scrollTop = $(window).scrollTop();
    const windowHeight = $(window).height();
    const lastClosed = localStorage.getItem(POPUP_KEY);
    const offSetTop = $('.home-projects').offset().top;

    // Check if delay has passed
    const now = Date.now();
    const delayPassed = !lastClosed || now - parseInt(lastClosed, 10) > POPUP_DELAY_MINUTES * 60 * 1000;

    if (scrollTop > offSetTop && delayPassed) {
      $popup.addClass('open');
    }
  }

  // Close popup and set timestamp
  function closeSubscribePopup() {
    $('.subscribe-popup').removeClass('open');
    localStorage.setItem(POPUP_KEY, Date.now());
  }

  function handleNavToggle() {
    $('.nav-toggle').on('click', function () {
      $(this).toggleClass('open');
      $('html').toggleClass('nav-open');
    });
  }

  function handleMobileMenu() {
    if ($(window).width() <= 991) {
      $(document).on('click', '.main-navigation .menu-item-has-children > a', function (e) {
        e.preventDefault();
        $(this).toggleClass('on');
        $(this).next().slideToggle();
      });
    }
  }

  function initAOS() {
    AOS.init({
      easing: 'ease-in-out-sine',
      duration: 400,
      once: true,
    });
  }

  function toggleFooterText() {
    $(document).on('click', '.toggle-tgr', function () {
      $('.site-footer-content-in p:not(:first-child)').slideToggle();
      $(this).toggleClass('open');
    });
  }

  function initSliders() {
    $('.home-div-cl').slick({
      dots: false,
      infinite: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 10000,
      slidesToShow: 3,
      slidesToScroll: 1,
      swipeToSlide: true,
      centerMode: true,
      centerPadding: 0,
      cssEase: 'linear',
      pauseOnHover: true,
      responsive: [
        { breakpoint: 992, settings: { slidesToShow: 2 } },
        { breakpoint: 650, settings: { slidesToShow: 1 } },
      ]
    });
    $('.hww-logos').slick({
      dots: false,
      infinite: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 10000,
      slidesToShow: 5,
      slidesToScroll: 1,
      cssEase: 'linear',
      pauseOnHover: true,
      responsive: [
        { breakpoint: 1024 },
        { breakpoint: 992 },
        { breakpoint: 550 },
      ]
    });

    $('.single-image-cl').slick({
      dots: false,
      infinite: true,
      arrows: false,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true
    });



    $('.home-testi-cl').slick({
      dots: false,
      infinite: true,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 10000,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: '<span class="slick-arrow slick-next"><svg width="2.3125rem" height="2.3125rem" viewBox="0 0 37 37" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><rect width="37" height="37" fill-rule="nonzero" rx="18.5"/><path stroke="#000000" stroke-width="2" d="M16 13L21.5 18.5 16 24"/></svg></span>',
      prevArrow: '<span class="slick-arrow slick-prev"><svg width="2.3125rem" height="2.3125rem" viewBox="0 0 37 37" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><rect width="37" height="37" fill-rule="nonzero" rx="18.5" transform="rotate(-180 18.5 18.5)"/><path stroke="#000000" stroke-width="2" d="M21 24L15.5 18.5 21 13"/></svg></span>',
    });

    $('.home-testi-cl').on('afterChange', function (e, slick, current) {
      const src = $(`[data-slick-index='${current}']`).find('.home-testi-cl-item').data('image');
      $('.home-testi-in > img').attr('src', src);
    });
    $('.testimonials-cl').slick({
      dots: false,
      infinite: true,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 5000,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: '<span class="slick-arrow slick-next"><svg width="2.3125rem" height="2.3125rem" viewBox="0 0 37 37" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><rect width="37" height="37" fill-rule="nonzero" rx="18.5"/><path stroke="#000000" stroke-width="2" d="M16 13L21.5 18.5 16 24"/></svg></span>',
      prevArrow: '<span class="slick-arrow slick-prev"><svg width="2.3125rem" height="2.3125rem" viewBox="0 0 37 37" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><rect width="37" height="37" fill-rule="nonzero" rx="18.5" transform="rotate(-180 18.5 18.5)"/><path stroke="#000000" stroke-width="2" d="M21 24L15.5 18.5 21 13"/></svg></span>',
    });

    $('.community-cl').slick({
      dots: false,
      infinite: true,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 5000,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: '<span class="slick-arrow slick-next"><svg width="2.3125rem" height="2.3125rem" viewBox="0 0 37 37" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><rect width="37" height="37" fill-rule="nonzero" rx="18.5"/><path stroke="#000000" stroke-width="2" d="M16 13L21.5 18.5 16 24"/></svg></span>',
      prevArrow: '<span class="slick-arrow slick-prev"><svg width="2.3125rem" height="2.3125rem" viewBox="0 0 37 37" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><rect width="37" height="37" fill-rule="nonzero" rx="18.5" transform="rotate(-180 18.5 18.5)"/><path stroke="#000000" stroke-width="2" d="M21 24L15.5 18.5 21 13"/></svg></span>',
    });

    $('.community-content-cl').slick({
      dots: false,
      infinite: true,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 1000,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: '<span class="slick-arrow slick-next"><svg width="2.3125rem" height="2.3125rem" viewBox="0 0 37 37" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><rect width="37" height="37" fill-rule="nonzero" rx="18.5"/><path stroke="#000000" stroke-width="2" d="M16 13L21.5 18.5 16 24"/></svg></span>',
      prevArrow: '<span class="slick-arrow slick-prev"><svg width="2.3125rem" height="2.3125rem" viewBox="0 0 37 37" xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="xMinYMin"><rect width="37" height="37" fill-rule="nonzero" rx="18.5" transform="rotate(-180 18.5 18.5)"/><path stroke="#000000" stroke-width="2" d="M21 24L15.5 18.5 21 13"/></svg></span>',
    });

    const projectsSets = {
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 5000,
      speed: 700,
      customPaging: function (slider, i) {
        const navitem = slider.$slides.eq(i).find('.project-card').data('title');
        return `<span>${navitem}</span>`;
      },
      responsive: [{ breakpoint: 992, settings: "unslick" }]
    };
    WebOnlySlider(".home-projects-cl", projectsSets, 992);

    const articleSets = {
      dots: false,
      arrows: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: false,
      responsive: [{ breakpoint: 992, settings: "unslick" }]
    };
    WebOnlySlider(".home-articles-cl", articleSets, 992);
  }

  function WebOnlySlider(selector, settings, breakpoint) {
    const slider = $(selector);
    slider.slick(settings);

    $(window).on("resize", function () {
      if ($(window).width() >= breakpoint && !slider.hasClass("slick-initialized")) {
        slider.slick(settings);
      }
    });
  }

  function setupArrowNavigation() {
    const $slider = $(".home-articles-cl");
    const $prev = $(".cs-arrow-l");
    const $next = $(".cs-arrow-r");

    function updateArrows(slick, currentSlide) {
      $prev.toggleClass("disabled", currentSlide === 0);
      $next.toggleClass("disabled", currentSlide + slick.options.slidesToShow >= slick.slideCount);
    }

    $slider.on("init reInit afterChange", function (e, slick, current) {
      updateArrows(slick, current);
    });

    $prev.on("click", () => $slider.slick("slickPrev"));
    $next.on("click", () => $slider.slick("slickNext"));
  }

  function setupGformLabelAnimation(context = document) {
    const $inputs = $(context).find('.gform_wrapper.gravity-theme input[type="email"], .gform_wrapper.gravity-theme input[type="text"], .gform_wrapper.gravity-theme input[type="tel"]');

    $inputs.each(function () {
      if ($(this).val().trim() !== '') {
        $(this).closest('.gfield').addClass('has-value');
      } else {
        $(this).closest('.gfield').removeClass('has-value');
      }
    });
  }
  function handleConsentCheckbox(context = document) {
    $(context).find('.home-subscribe .ginput_container_consent input, .subscribe-popup  .ginput_container_consent input').each(function () {
      const $field = $(this).closest('.gfield');
      if ($(this).is(':checked')) {
        $field.addClass('visible');
      } else {
        $field.removeClass('visible');
      }
    });
  }
  function playVideoInline() {
    $('#play-btn').on('click', function () {
      var video = $('#about-video').get(0);
      video.controls = true;
      video.muted = false;
      video.play();
      $(this).fadeOut(); // Hide play button on click
    });
  }
  function handleFilterToggle() {
    $('.filter-trigger').on('click', function () {
      $(this).toggleClass('open');
      $(this).next().slideToggle();
    });
  }

  function handleFilteResultLoad() {
    $(document).on('submit', '.filter-content form', function (e) {
      e.preventDefault(); // Prevent default form submission

      var $form = $(this);
      var actionUrl = $form.attr('action');
      var formData = $form.serialize(); // Serialize form data

      // Combine URL with serialized data as query string
      var fullUrl = actionUrl + (actionUrl.indexOf('?') > -1 ? '&' : '?') + formData;
      // Load content into a temporary wrapper and append it
      $('body').addClass('loading');
      $("<div>").load(fullUrl + " #loadmorecontainer", function () {
        $("#loadmorecontainer").html($(this).find("#loadmorecontainer").html());
        $('body').removeClass('loading');
      });
      console.log(fullUrl);
    });

    $(document).on('click', '.loadmore', function (e) {
      e.preventDefault();
      var $el = $(this),
        link = $el.attr('href');
      if ($el.attr('disabled'))
        return;
      $el.addClass('loading').attr('disabled', true);
      $el.find('span').html('Loading...')
      $('body').addClass('loading');
      $("<div>").load(link + " #loadmorecontainer", function () {
        $("#loadmorecontainer").append($(this).find("#loadmorecontainer").html());
        $el.parents('.load-more').removeAttr('disabled').remove();
        $('body').removeClass('loading');
        triggerPreloading();
      });
    });

    $('.filter-list-item input').each(function () {
      $(this).on('change', function () {
        $(this).parents('form').submit();
      });
    });

  }
  function triggerPreloading() {
    if ($('.loadmore').length) {
      var triggered = false;
      var $targetElement = $('#loadmorecontainer');  // replace with your element ID or class
      var $button = $('.loadmore');          // replace with your button selector

      $(window).on('scroll', function () {
        if (triggered) return; // prevent multiple triggers

        var windowTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var elementTop = $button.offset().top;
        var triggerPoint = elementTop - windowHeight - 100; // 20% above the element

        if (windowTop >= triggerPoint) {
          $button.trigger('click');
          triggered = true;
        }
      });
    }
  }
  function slidePopup() {
    // Open popup

    $('.slide-popup-trigger').on('click', function (e) {
      e.preventDefault();
      var target = $(this).data('target'); // Get data-target if it exists
      var title = $(this).data('title'); // Get data-target if it exists
      if (target) {
        $(target).addClass('active');
      } else {
        $('.slide-popup').addClass('active'); // Default fallback
      }
      if (title) {
        $('.slide-popup-head .section-title').text(title);
      }
      $('html').addClass('awsm-popup-open awsm-popup-on');
    });

    // Close popup

    $(document).on('click', '.slide-popup-close', function (e) {
      e.preventDefault();
      var $popup = $(this).closest('.slide-popup');
      $popup.removeClass('active');
      if (!$('.slide-popup.active').length) {
        $('html').removeClass('awsm-popup-open awsm-popup-on');
      }
    });

    // Click outside to close

    $(document).on('click', '.slide-popup', function (e) {
      if (!$(e.target).closest('.slide-popup-in').length) {
        $(this).removeClass('active');
        if (!$('.slide-popup.active').length) {
          $('html').removeClass('awsm-popup-open awsm-popup-on');
        }
      }
    });


  }
  function divisionToggle() {
    $('.division-item-toggle').on('click', function (e) {
      e.preventDefault();
      $(this).parents('.division-item').toggleClass('open');
      $(this).toggleClass('open');
      if ($(window).width() > 991) {
        $(this).parents('.division-item').find('.dic-contact').slideToggle();;
      } else {
        $(this).parents('.division-item').find('.division-item-cnt').slideToggle();
      }
    });
  }



  // Init functions
  //setAppHeight();
  setTimeout(setAppHeight, 100);
  handleNavToggle();
  handleMobileMenu();
  initAOS();
  toggleFooterText();
  initSliders();
  setupArrowNavigation();
  //setupGformLabelAnimation();
  playVideoInline();
  handleFilterToggle();
  handleFilteResultLoad();
  slidePopup();
  triggerPreloading();
  divisionToggle();

  $(document).on('focus', '.gform_wrapper.gravity-theme input[type="email"], .gform_wrapper.gravity-theme input[type="text"], .gform_wrapper.gravity-theme input[type="tel"]', function () {
    $(this).closest('.gfield').addClass('has-value');
  });

  $(document).on('blur', '.gform_wrapper.gravity-theme input[type="email"], .gform_wrapper.gravity-theme input[type="text"], .gform_wrapper.gravity-theme input[type="tel"]', function () {
    if ($(this).val().trim() === '') {
      $(this).closest('.gfield').removeClass('has-value');
    }
  });
  $(document).on('change', '.home-subscribe .ginput_container_consent input, .subscribe-popup  .ginput_container_consent input', function () {
    const $field = $(this).closest('.gfield');
    if ($(this).is(':checked')) {
      $field.addClass('visible');
    } else {
      $field.removeClass('visible');
    }
  });

  // Call once on DOM ready
  $(document).ready(function () {
    setupGformLabelAnimation();
    handleConsentCheckbox();
  });

  // Re-run after Gravity Forms AJAX finishes rendering a form
  $(document).on('gform_post_render', function (event, form_id) {
    setupGformLabelAnimation('#gform_wrapper_' + form_id);
    handleConsentCheckbox('#gform_wrapper_' + form_id);
  });


  $(window).on('resize', setAppHeight);
  $(window).on('scroll load', handleScrollEffects);

  $('.companies-card').on('click', function () {
    const $desc = $(this).find('.companies-card-desc');
    if ($(this).attr('data-status') === 'more') {
      $desc.addClass('expanded');
      $(this).find('.desc-read-more').text('Read Less');
      $(this).attr('data-status', 'less');
    } else {
      $desc.removeClass('expanded');
      $(this).find('.desc-read-more').text('Read More');
      $(this).attr('data-status', 'more');
    }
  });
  $('.careers-cl').slick({
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
    fade: true,
    cssEase: 'linear',
    nextArrow: '<a href="#" class="slick-arrow slick-next custom-slick-arrow"></a>',
    prevArrow: '<a href="#" class="slick-arrow slick-prev custom-slick-arrow"></a>',
    dots: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          arrows: false,
        }
      },
    ],
  });

  $('.gform_wrapper.gravity-theme .gfield.resume input').on('change', function () {
    var fileName = this.files[0]?.name || '';
    if (fileName) {
      $(this).next('.gform_fileupload_rules').text(fileName).addClass('selected');
    }
  });

  $(document).on("click", ".copyclip", function (e) {
    e.preventDefault();
    var textToCopy = $(this).data("text");
    var tempTextarea = $("<textarea>");
    $("body").append(tempTextarea);
    tempTextarea.val(textToCopy).select();
    document.execCommand("copy");
    tempTextarea.remove();
    //$(this).text("Copied");
  });

  // Initialize filters
  $('.filter-content').each(function () {
    initFilter($(this));
  });

  openSubscribeForm();
  $(window).on('scroll', openSubscribeForm);

  // Example: close button
  $(document).on('click', '.subscribe-popup-close', function (e) {
    e.preventDefault();
    closeSubscribePopup();
  });

  function initFilter($container) {
    const postType = $container.data('ptype');
    const $form = $container.find('form');
    const $content = $container.find('.filter-content');
    const $checkboxes = $container.find('input');
    const $submitBtn = $container.find('.submit-btn');
    const $clearBtn = $container.find('.filter-clear');
    const $countDisplay = $container.find('.count-display');

    // State object to track selected terms
    let selected = {};

    // Handle checkbox changes
    $checkboxes.on('change', function () {
      updateSelectedState();
      checkFilterAvailability();
    });
    $clearBtn.on('click', function (e) {
      e.preventDefault();
      var $el = $(this),
        link = $el.attr('href');
      $('body').addClass('loading');
      $("<div>").load(link + " #loadmorecontainer", function () {
        $("#loadmorecontainer").html($(this).find("#loadmorecontainer").html());
        $('body').removeClass('loading');
      });
      $checkboxes.prop('checked', false);
      updateSelectedState();
      checkFilterAvailability();

    });

    // Clear all filters
    /*$clearBtn.on('click', function(e) {
        e.preventDefault();
        $checkboxes.prop('checked', false);
        updateSelectedState();
        checkFilterAvailability();
    });*/

    // Initial check if there are already checkboxes selected
    if ($checkboxes.filter(':checked').length > 0) {
      updateSelectedState();
      checkFilterAvailability();
    } else {
      // Set initial count to total posts
      updateTotalCount();
    }

    // Update the selected state object
    function updateSelectedState() {
      selected = {};

      $checkboxes.filter(':checked').each(function () {
        const taxonomy = $(this).data('taxonomy');
        const term = $(this).data('term');

        if (!selected[taxonomy]) {
          selected[taxonomy] = [];
        }

        selected[taxonomy].push(term);
      });
    }

    // Get initial total count
    function updateTotalCount() {

      $.ajax({
        url: thirdidata.ajax_url,
        type: 'POST',
        data: {
          action: 'check_filter_state',
          p_type: postType,
          selected: {}
        },
        success: function (response) {
          updateCountDisplay(response.total_count);
        }
      });
    }

    // Check which filters should be available based on current selection
    function checkFilterAvailability() {
      $.ajax({
        url: thirdidata.ajax_url,
        type: 'POST',
        data: {
          action: 'check_filter_state',
          p_type: postType,
          selected: selected
        },
        success: function (response) {
          updateFilters(response);
          updateCountDisplay(response.total_count);
        },
        error: function (xhr, status, error) {
          console.error('Error checking filter availability:', error);
        },
        complete: function () {
          $container.removeClass('loading');
        }
      });
    }

    // Update filter options based on response
    function updateFilters(response) {
      // Process each taxonomy
      for (const taxonomy in response.taxonomies) {
        const terms = response.taxonomies[taxonomy];

        // Update each term checkbox
        for (const termSlug in terms) {
          const termData = terms[termSlug];
          const className = 'tax-' + taxonomy.replace(/[^a-zA-Z0-9]/g, '-') + '-term-' + termSlug.replace(/[^a-zA-Z0-9]/g, '-');
          const $checkbox = $container.find('.' + className);
          // Disable/enable based on availability
          $checkbox.prop('disabled', !termData.available);

        }
      }
    }

    // Update the count display in the submit button
    function updateCountDisplay(count) {
      $countDisplay.text(`(${count})`);
    }
  }

  $('.view-more').on('click', function (e) {
    e.preventDefault();
    $('.scroll-down').slideToggle();
    var $text = $('.view-more').find('.toggle-text');
    if ($text.text().trim() == "View More") {
      $text.text("View Less");

    } else {
      $text.text("View More");
    }
  });

  if ($('.division-item').length) {
    const hash = window.location.hash;
    if (hash) {
      const $target = $(hash);
      if ($target.length) {
        $target.addClass('open'); // Replace 'highlight' with your desired class
        $target.find('.dic-contact').show();
      }
    }
  }
  var Device = {
    touch: false,
    screenWidth: 0,
    screenHeight: 0,
    pixelRes: 1,
    parallax: true,
    initScreenHeight: 0,
    salesforce: false,
    init: function init() {
      /* Detect touch device */
      if ('ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
        Device.touch = true;
        document.body.classList.add('state-touch');
      } else {
        document.body.classList.add('state-no-touch');
      }
    },
  };
  var Mouse = {
    cursor: null,
    mouseActive: false,
    sliderContainer: null,
    init: function init() {
      if (Device.touch === false) {
        Mouse.cursor = document.querySelector('.custom-cursor');
        Mouse.sliderContainer = document.querySelector('.careers-banner-imgs'); // target slider only

        if (Mouse.sliderContainer && Mouse.cursor) {
          Mouse.sliderContainer.addEventListener('mousemove', function (event) {
            Mouse.cursor.style.transform = 'translate3d(' + event.pageX + 'px,' + event.pageY + 'px,0px)';
            if (!Mouse.mouseActive) {
              Mouse.mouseActive = true;
              Mouse.sliderContainer.classList.add('state-show-mouse');
            }
          });

          Mouse.sliderContainer.addEventListener('mouseleave', function (event) {
            Mouse.cursor.style.transform = 'translate3d(' + event.pageX + 'px,' + event.pageY + 'px,0px)';
            Mouse.mouseActive = false;
            Mouse.sliderContainer.classList.remove('state-show-mouse');
          });
        }
      }
    },
    bindEvents: function bindEvents() {
      var _els = document.querySelectorAll('.careers-banner-imgs .custom-slick-arrow'); // target arrows inside slider only

      if (_els.length > 0) {
        _els.forEach(function (el) {
          if (!el.classList.contains('js-hover-setup')) {
            el.classList.add('js-hover-setup');

            el.addEventListener('mouseover', function (evt) {
              if (evt.target.classList.contains('slick-next')) {
                Mouse.sliderContainer.classList.add('state-hover-next');
                Mouse.sliderContainer.classList.remove('state-hover-prev');
                Mouse.sliderContainer.classList.add('state-mouse-hover');
              } else if (evt.target.classList.contains('slick-prev')) {
                Mouse.sliderContainer.classList.remove('state-hover-next');
                Mouse.sliderContainer.classList.add('state-hover-prev');
                Mouse.sliderContainer.classList.add('state-mouse-hover');
              } else {
                Mouse.sliderContainer.classList.remove('state-hover-prev');
                Mouse.sliderContainer.classList.remove('state-hover-next');
                Mouse.sliderContainer.classList.add('state-mouse-hover');
              }
            });

            el.addEventListener('mouseout', function () {
              Mouse.sliderContainer.classList.remove('state-mouse-hover');
              Mouse.sliderContainer.classList.remove('state-hover-next');
              Mouse.sliderContainer.classList.remove('state-hover-prev');
            });
          }
        });
      }
    }
  };

  Mouse.init();
  Mouse.bindEvents();


  $('.video-popup').magnificPopup({
    type: 'iframe',
    iframe: {
      markup: '<div class="mfp-iframe-scaler">' +
        '<div class="mfp-close"></div>' +
        '<iframe class="mfp-iframe" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>' +
        '</div>',
      patterns: {
        vimeo: {
          index: 'vimeo.com/',
          id: function (url) {
            var match = url.match(/vimeo\.com\/(\d+)/);
            return match ? match[1] : null;
          },
          src: 'https://player.vimeo.com/video/%id%?autoplay=1'
        }
      },
      srcAction: 'iframe_src',
    }
  });
  $(function () {
    $('.beforeAfter').beforeAfter();
  });
  $(document).on('change input blur', '.project-selector select', function (e) {
    var $name = $(this).find('option:selected').text();
    $('.sf-project-id input').val($name);
  });
  $('#generate-letter').on('click', function() {
        var selected = [];
        $('.acf-reasons-populate input:checked').each(function() {
            selected.push($(this).val());
        });

        var $btn = $(this);
        $btn.prop('disabled', true).text('Generating...');
        $.ajax({
            url: thirdidata.ajax_url,
            method: 'POST',
            data: {
                action: 'generate_support_letter',
                nonce: thirdidata.nonce,
                inputs: selected
            },
            success: function(response) {
                $btn.prop('disabled', false).text('Generate Letter');
                if (response.success && response.data.letter) {
                    $('#input_8_22').val(response.data.letter); // Replace with correct Gravity Forms textarea ID
                } else {
                    alert('Could not generate letter.');
                }
            },
            error: function() {
                $btn.prop('disabled', false).text('Generate Letter');
                alert('AJAX error occurred.');
            }
        });
    });
});